// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1X7rf","Open":"SideDrawer_Open__1JcBS","Close":"SideDrawer_Close__1bMMg","Logo":"SideDrawer_Logo__2Osc5"};